/** @module Sourcing/CopySupplierRequest */
define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"./CopySupplierRequestMixin"
], function(declare,Copy,CopySupplierRequestMixin) {
	return declare([Copy, CopySupplierRequestMixin], {

		/**
		 * @override
		 * C8-18976
		 * Add the Save & Go button to Supplier Request Copy Form
		 */
		addProxyActions: function(defView, defActions) {
			defActions.addAction(this.getProxyAction("Save_Go", true));
			this.inherited(arguments);
		}
	});
});
